import { render, staticRenderFns } from "./AccountingStatusLabel.vue?vue&type=template&id=27520cea&"
import script from "./AccountingStatusLabel.vue?vue&type=script&lang=js&"
export * from "./AccountingStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./AccountingStatusLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports